export default __webpack_public_path__ + "static/media/safersale.0d883b13.jpg";